import { Inspector, Flex } from '@sequencehq/core-components'
import { FC, ReactNode } from 'react'
import { attioIntegrationConfig } from '../attio.integration.config'
import { LinkCustomerToServiceWidget } from '../../common/LinkEntities/LinkCustomerToService'
import { SmallIcon } from 'Integrations/integrationsConfig/common/SmallIcon'
import { useLinkCustomerToService } from 'Integrations/integrationsConfig/common/LinkEntities/LinkCustomerToService/LinkCustomerToServiceWidget/useLinkCustomerToService'
import { LinkEntityWidget } from 'Integrations/integrationsConfig/common/LinkEntities/LinkEntityWidget'
import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'

export const LinkAttioCustomerWidget: FC<{
  customerId: string
}> = props => (
  <LinkCustomerToServiceWidget
    customerId={props.customerId}
    sequenceEntityLabel="customer"
    externalEntityLabel="customer"
    service="Attio"
    canUnlink={false}
    hideWhenNoLink
  />
)

export const AttioCustomerInspectorItem: FC<{
  children: ReactNode
  customerId: string
}> = props => {
  // Done this way to hide the widget altogether if the customer is not linked
  const { linkedAccount } = useLinkCustomerToService({
    customerId: props.customerId,
    service: 'Attio',
    canUnlink: false
  })

  if (!linkedAccount.value) {
    return null
  }

  return (
    <Inspector.IconItem
      data-testid="Attio.inspector.item"
      content={
        <Inspector.Content
          title="Attio"
          icon={<SmallIcon url={attioIntegrationConfig.smallLogoUrl} />}
          data-testid="Attio.inspector.content"
        >
          <Flex flexDirection="column" gap="16px">
            {props.children}
          </Flex>
        </Inspector.Content>
      }
      tooltip="Attio"
      icon={<SmallIcon url={attioIntegrationConfig.smallLogoUrl} />}
    />
  )
}

export const AttioQuoteInspectorItem: FC<{
  quoteId: string
}> = props => {
  const { data: integration } = useQuery(
    dashboard20240730Client.getQuote,
    {
      id: props.quoteId
    },
    {
      enabled: !!props.quoteId,
      select: data => {
        return data?.integrationIds?.find(
          integration => integration.service === 'Attio'
        )
      }
    }
  )

  if (!integration) {
    return null
  }

  return (
    <Inspector.IconItem
      data-testid="Attio.inspector.item"
      content={
        <Inspector.Content
          title="Attio"
          icon={<SmallIcon url={attioIntegrationConfig.smallLogoUrl} />}
          data-testid="Attio.inspector.content"
        >
          <Flex flexDirection="column" gap="16px">
            <LinkEntityWidget
              data-testid={`attio.linkCustomer`}
              canLink={false}
              externalEntityLabel="Attio deal"
              sequenceEntityLabel="Quote"
              isLoaded
              serviceName="Attio"
              linkedAccount={{
                label: integration.id,
                href: integration.url,
                canUnlink: false,
                isPending: false
              }}
            />
          </Flex>
        </Inspector.Content>
      }
      tooltip="Attio"
      icon={<SmallIcon url={attioIntegrationConfig.smallLogoUrl} />}
    />
  )
}
